import React from "react";

const ExitIcon = ({ color = "#FFF", width = 24, height= 24, className = "", ...props }) => (
        <svg width={width}
             height={height}
             viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             className={className}
             {...props}>
            <path
                d="M15.8676 8.4499V6.1749C15.8676 5.57153 15.6259 4.99288 15.1957 4.56623C14.7655 4.13959 14.182 3.8999 13.5735 3.8999H5.54412C4.93568 3.8999 4.35216 4.13959 3.92193 4.56623C3.4917 4.99288 3.25 5.57153 3.25 6.1749V19.8249C3.25 20.4283 3.4917 21.0069 3.92193 21.4336C4.35216 21.8602 4.93568 22.0999 5.54412 22.0999H13.5735C14.182 22.0999 14.7655 21.8602 15.1957 21.4336C15.6259 21.0069 15.8676 20.4283 15.8676 19.8249V17.5499M8.98529 12.9999H22.75M22.75 12.9999L19.3088 9.5874M22.75 12.9999L19.3088 16.4124"
                stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
;

export default ExitIcon;